import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import { nanoid } from 'nanoid'
import moment from 'moment'
import common_helper from '../../../common_helper'

export default {
  name: 'inward',
  components: {
    vSelect,
    DatePicker,
    Loader
  },
  props: ['selectedRow', 'filterData'],
  data: function () {
    return {
      inwardErrors: {},
      result: [],
      inwardaction: '',
      addinwardmodal: false,
      listPOData: [],
      listInwardData: [],
      listSupplierData: [],
      counter: 0,
      isLoading: false,
      //to close the modal(dependent form field)
      poerrors: '',
      deletemodal : false,
      Dateerrors: '',
      isDateError: '',
      isError: '',
      referenceNo: '',
      createdbyEmail: '',
      Qtyerrors: '',
      POmapflag: false,
      invoicedate: null,
      modalMessageShowpo: false,
      validate_po_mandate: false,
      emptyPO: '',
      // initialize form field
      addinward: {
        transporter: '',
        invoiceno: '',
        invoicevalue: '',
        invoicedate: null,
        noofboxes: '',
        damagedboxes: '',
        damagereasons: '',
        client: '',
        Lr: '',
        vehicleno: '',
        vendor: '',
        materialdesc: '',
        comments: '',
        status: '',
        SKU: '',
        InvoiceQty: '',
        pono: '',
        isSearching: '',
        warehouseid: '',
        merchantid: '',
        baseUrl: apiUrl.api_url,
        invoiceid: '',


      },

      listMerchantData: [],
      listClientData: [],
      listWarehouseData: [],
      merchant: '',
      merchantid: '',
      client: '',
      clientid: '',
      warehouse: '',
      warehouseid: '',
      showSelectClient: false,
      showSelectWarehouse: false,
      clientList: [],
      warehouseList: [],
      merchantList: [],
      ClientErr: '',
      WarehouseErr: '',
      grcstarted: '',
      shorturl : '',
      invoiceUrl : '',
      showupdateinvoice:false,
      file:'',
      isNewInvoice : false,
      updatedinvoiceurl:'',
      invreferenceid :'',
      invoiceExpiry:'',
      counter:'',
      isinvoiceexpired:0,
      updatedatainvoice:false
    }
  },
  computed: {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
      case 'warehouse_user':
        this.createdbyEmail = userdetail.email;
        break;

      case 'client_user':
      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }


    if (this.selectedRow) {

      this.inwardid = this.selectedRow.inwardid;
      this.clientid = this.selectedRow.clientid;
      this.warehouseid = this.selectedRow.warehouseid;
      this.grcstarted = this.selectedRow.grcstarted,
      this.shorturl = this.selectedRow.shorturl,
      this.invoiceExpiry = this.selectedRow.expirydate,
      this.counter = this.selectedRow.counter,
      this.invreferenceid = this.selectedRow.invreferenceid,
      this.getDRDetailsForEdit();
      this.getMerchantList();
    }
  },
  methods: {
    showList() {
      this.$emit("goBackToParent")
    },
    updateinvoiceUrl(){
        this.isNewInvoice= true;
        this.updatedatainvoice=true;
    },
    closeupdateinvoiceUrl(){
        this.updatedatainvoice = false;
    },

    getMerchantList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: this.clientid,
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'merchantList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data && result.data.length > 0) {
            this.listMerchantData = result.data;
            var merchantListArray = [];
            result.data.forEach(function (item) {
              merchantListArray[item.merchantid] = item.merchantname;
            });
            this.merchantList = merchantListArray;
          }
        }, error => {
          console.error(error);
        })
    },

    merchantSelected() {
      this.merchantid = this.addinward.vendor;
      if (this.merchantid) { }
    },

    //deletes target records
    removeRow: function (index) {
      this.listPOData.splice(index, 1);
      this.POmapflag = false;
      this.searchPO()
    },

    getDRDetailsForEdit() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.isLoading = true;

      this.input = ({
        'clientid': this.clientid,
        'warehouseid': this.warehouseid,
        'inwardid': this.inwardid,
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getMaterialInwardDetails',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result && result.data) {
            if (result.data.length > 0) {
              //console.log(result);
              // if (result.data[0].grcstarted == false) {
              if (result.data[0].grcstarted == 1 || result.data[0].grcstarted == 0) {
                this.editDRData = result.data[0];
                this.addinward.vendor = this.editDRData.merchantid;
                this.addinward.transporter = this.editDRData.transportername;
                this.addinward.Lr = this.editDRData.lrnumber;
                this.addinward.vehicleno = this.editDRData.vehicleno;
                this.addinward.invoiceno = this.editDRData.challanno;
                this.addinward.invoicevalue = this.editDRData.invoicevalue;
                this.addinward.invoicedate = this.editDRData.invoicedate;
                this.addinward.SKU = this.editDRData.totalsku;
                this.addinward.InvoiceQty = this.editDRData.totalinvoiceqty;
                this.addinward.noofboxes = this.editDRData.noofboxes;
                this.addinward.damagedboxes = this.editDRData.damagedboxes;
                this.addinward.materialdesc = this.editDRData.materialdesc;
                this.addinward.comments = this.editDRData.comments;
                this.addinward.damagereasons = this.editDRData.damagereasons;
                this.addinward.pono = this.editDRData.pono;
                this.addinward.invoiceid = this.editDRData.invoiceurlid;
                this.addinward.invreferenceid = this.editDRData.invreferenceid;


                if (result.data[0].grcstarted == 1) {
                  this.$alertify.error('GR already in progress. PO cannot be edited');
                }

                if (this.editDRData.pono && this.POmapflag == false) {
                  this.POmapflag = true;
                  (this.editDRData.pono.trim() != '' && this.listPOData.indexOf(this.editDRData.pono) == -1) ? this.listPOData.push(this.editDRData.pono) : '';
                  this.addinward.emptyPO = '';
                  this.isError = '';
                  this.poerrors = '';
                  this.isDateError = '';
                  this.Dateerrors = '';
                }
              } else {
                // this.$alertify.error('GR already in progress. DR cannot be edited');
                this.$alertify.error('GR already in progress. PO cannot be edited');
              }
            } else {
              this.$alertify.error('Invalid DR / DR not exists');
            }
          } else {
            this.$alertify.error('Request cannot be completed');
          }
        }, error => {
          console.error(error);
        });

      this.isLoading = false;
    },

    async uploadInvoiceDoc(){
			return new Promise(async(resolve, reject) => {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				 if (!this.file) {
					this.$alert("Select File")
					return false
				}
				if (this.file) {
					var path = document.getElementById('file');
					if (!path.value == "") {
						var pdf = path.files[0].size;
						var pdfsize = pdf / 1024;
						if (pdfsize > 51200) {
							this.$alert("Pdf size cannot be uploaded greater than 50mb size")
							document.getElementById('file').value = null
							this.file=null
              this.isLoading = false;
							return false;
						}
					}
				}
        this.isLoading = true
        var selectedFile = document.getElementById("file").files;
        var fileToLoad = selectedFile[0];

        let reader = new FileReader()
					reader.readAsDataURL(fileToLoad)
					let pdfStream = await new Promise((resolve, reject) => {
						reader.onload = function () {
							this.base64String = reader.result.replace("", "")
							resolve(this.base64String)
						}
					})
       
        let result = await axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'uploadfile',
          'data': {
            body: pdfStream,
            key: 'dr/invoice/'+this.invreferenceid+'.pdf'
          },
          'headers': {
            'Authorization': 'Bearer ' + myStr,
          }
        })
					.then(async (response) => {
						this.longurl = response.data.url;
						this.shorturl = nanoid(10);
						let inputpayload2 = {
							clientid:this.clientid,
							warehouseid:this.warehouseid,
							drno :this.invreferenceid,
							longurl : this.longurl,
							shorturl:this.shorturl
						};
					 let saveUrl = await common_helper.getRestApiResponse('POST', 'saveInvoiceUrl', inputpayload2,this.$alertify)
						 if(saveUrl){
							 this.isLoading = false;
							 resolve(this.shorturl)
						 }
						 this.isLoading = false;
					})
					this.isLoading = false;
		})
		},
    //on selecting vendor's dropdown option opens the modal(depending form fields)
    addVendor() {
      this.input = ({});
      if (this.addinward.vendor) {
        this.$validator.reset();
      }
    },
    uploadinvoice(){
      this.showupdateinvoice=true;
   },
   handleFileUpload(){
     this.file = this.$refs.file.files[0];
     this.showupdateinvoice=true;
     if (!this.file) {
       this.$alert("Select File")
       return false
     }
     if (this.file) {
       var path = document.getElementById('file');
       if (!path.value == "") {
         var pdf = path.files[0].size;
         var pdfsize = pdf / 1024;
         if (pdfsize > 51200) {
           this.$alert("Pdf size cannot be uploaded greater than 50mb size")
           document.getElementById('file').value = null
           this.file=null
           this.isLoading = false;
           return false;
         }
       }
     }
   },

    // save form fields in database
    async saveInward() {
      
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.isLoading = true;
      if(this.file && this.deletemodal == false){
        this.deletemodal = true;
        this.isLoading = false;
        return false;
      }
      if (this.validate_po_mandate && this.listPOData.length < 1) {
        this.addinward.emptyPO = '1';
        this.poerrors = 'Map atleast one PO';
        this.isLoading = false;
        return false;
      } else {
        this.addinward.emptyPO = '';
      }
      let POs = [];
      for (let x = 0; x < this.listPOData.length; x++) {
        POs[x] = {
          srno: (x + 1),
          pono: this.listPOData[x].trim(),
        };
      }
      if(this.file ){
        if(!this.addinward.invoiceid){
          let resultnewurl = await this.uploadInvoiceDoc()
          this.updatedinvoiceurl = resultnewurl
        }
        if(this.isNewInvoice && this.addinward.invoiceid){
         let resulturl = await this.saveInvoice()
          this.updatedinvoiceurl = resulturl
        }
      }
      let input = {
        'clientid': this.clientid,
        'warehouseid': this.warehouseid,
        'merchantid': this.addinward.vendor,
        'inwardid': this.inwardid,
        'transportername': this.addinward.transporter,
        'lrnumber': this.addinward.Lr,
        'vehicleno': this.addinward.vehicleno,
        'challanno': this.addinward.invoiceno,
        'invoicevalue': this.addinward.invoicevalue,
        'invoicedate': this.getdate1(this.addinward.invoicedate),
        'materialdesc': this.addinward.materialdesc,
        'totalsku': this.addinward.SKU,
        'totalinvoiceqty': this.addinward.InvoiceQty,
        'noofboxes': this.addinward.noofboxes,
        'damagedboxes': ((this.addinward.damagedboxes) ? Number(this.addinward.damagedboxes) : 0),
        'damagereasons': ((this.addinward.damagereasons) ? (this.addinward.damagereasons) : ''),
        'comments': this.addinward.comments,
        'createdby': this.createdbyEmail,
        'podetails': POs,
        'invoiceurl' : this.updatedinvoiceurl,
        'invoiceid' : this.addinward.invoiceid,
        'invreferenceid':this.addinward.invreferenceid,
        'isinvoiceexpired':this.isinvoiceexpired
      };
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'updateInward',
        'data': input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response && response.data) {
            if(response.data.data.isInvoiceupload == false){
              this.$alertify.error("Invoice update failed.Please check data or threshold to update invoice url");
            }
            if (response.data.status) {
              this.$alertify.success(response.data.msg);
              this.input = ({
                'drno': response.data.data.invreferenceid,
                'clientid': this.clientid,
              })
              axios({
                method: 'POST',
                'url': apiUrl.api_url + 'elsdr',
                'data': this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
                .then(() => {
                  this.isLoading = false;
                  document.body.classList.remove('modal-open');
                  this.gotoListPage()
                })
                .catch((httpException) => {
                  console.error('exception is:::::::::', httpException)
                });
            } else {
              this.$alertify.error(response.data.msg);
            }
          } else {
            this.$alertify.error('DR cannot be updated at the moment');
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        });
      //this.isLoading = false;/
    },

    //to search the entered PO
    searchPO() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.addinward.pono.length > 0) {
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'ValidatePO',
          'data': {
            'pono': this.addinward.pono.trim(),
            'warehouseid': this.warehouseid,
            'merchantid': Number(this.addinward.vendor),
            'clientid': this.clientid,
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            this.POCreatedDate = response.data.data.createddate;
            if (response.data.errorCode == 0) {
              this.DateList = response.data.data.deliverbydateterms;
              var today = new Date();
              var deliverbydate = new Date(this.DateList);
              if (Date.parse(deliverbydate) >= Date.parse(today)) {
                this.isDateError = '';
                this.Dateerrors = '';
              } else {
                this.isError = '1';
                this.poerrors = 'Invalid delivery date';
              }
              axios({
                method: 'POST',
                'url': apiUrl.api_url + 'ValidateSearchPO',
                'data': {
                  'pono': this.addinward.pono.trim(),
                  'warehouseid': this.warehouseid,
                  'clientid': this.clientid,
                  'inwardid': this.inwardid,
                },
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
                .then((response) => {
                  if (response.data.errorCode == 0) {
                    if (this.POmapflag == false) {
                      this.POmapflag = true;
                      //doesn't adds duplicates and push the PO result in array
                      this.addinward.pono.trim() != '' && this.listPOData.indexOf(this.addinward.pono) == -1 ? this.listPOData.push(this.addinward.pono) : '';
                      // this.addinward.pono = '',
                      this.addinward.emptyPO = ''
                      this.isError = '';
                      this.poerrors = '';
                      this.isDateError = '';
                      this.Dateerrors = '';
                      this.$alertify.success("PO mapped successfully")
                    } else {
                      this.$alertify.error("you can't map more than one PO")
                    }
                  } else {
                    this.isError = '1';
                    this.poerrors = 'PO already mapped to another Dock Receipt';
                  }
                })
            } else {
              this.isError = '1';
              if (response.data.data[0] && response.data.data[0].status == 'Cancel') {
                this.poerrors = 'PO is Cancle please choose another PO'
                this.addinward.pono = ''
              }
              else {
                this.poerrors = 'Merchant in PO is different from selected Merchant OR PO does not exist. Please choose another PO';
                this.addinward.pono = ''

              }

            }
          })
      } else {
        this.isError = '1';
        this.poerrors = 'Please enter atleast 5 digit';
      }
    },

    submitFile(){
      this.deletemodal = true;
     },

     closedeletemodal() {
			this.deletedata = {};
			this.deletemodal = false;
		},

    viewfile () {
      if(this.shorturl){
        var today = new Date();
        let currentDate = new Date();
        this.invoiceExpiry = new Date(this.invoiceExpiry);
        //if (currentDate.getTime() < this.invoiceExpiry.getTime())
        if(this.invoiceExpiry && currentDate.getTime() > this.invoiceExpiry.getTime()){
            this.isinvoiceexpired = 1;
            this.updatedatainvoice= true;
        }
        if(this.isinvoiceexpired == 1){
          this.updatedatainvoice= true;
        }
        else{
          window.open(apiUrl.api_url+this.clientid+'/tiny/'+this.shorturl)
      } }
      else {
        this.$alertify.error("No Invoice Uploaded")
      }
    },

    uploadNewInvoice(){
      if(this.file){
        this.isNewInvoice = true;
      }
       return this.isNewInvoice
    },

    closeuploadNewInvoice(){
       setTimeout(function() {
        this.deletemodal = false;
      }, 100);
    },

    showSearch() {
      this.isError = '';
      this.poerrors = '';
      this.isDateError = '';
      this.Dateerrors = '';
    },

    nextInward() {
      this.referenceNo = '';
      this.addinward = [];
      this.invoicedate = null;
      this.listPOData = [];
      this.$validator.reset();
    },

    gotoListPage() {
      this.showList()
      this.modalMessageShowpo = false;
    },

    CheckQuantity() {
      if (Number(this.addinward.SKU) > Number(this.addinward.InvoiceQty)) {
        this.isError = '1';
        this.Qtyerrors = 'Quantity must be equal to or greater than SKU';
      } else {
        this.isError = '';
        this.Qtyerrors = '';
      }
    },

    resetform() {
      this.addinward.materialdesc = '';
      this.addinward.vendor = '';
      this.listPOData = [];
      this.$validator.reset();
      this.POmapflag = false;
      this.addinward.pono = '';
      this.isError = '';
      this.poerrors = '';
      this.getDRDetailsForEdit();
    },


    async saveInvoice(){
      return new Promise(async(resolve, reject) => {
        if (!this.file) {
           this.$alert("Select File")
           return false
       }
       if (this.file && this.isNewInvoice) {
         var path = document.getElementById('file');
             var pdf = path.files[0].size;
             if (this.file == '' || this.$refs.file.files[0].type != 'application/pdf' ) {
                 this.$alertify.error("Please select valid pdf file!");
                 this.deletemodal = false;
                 this.isLoading=false;
                 return false;
             }
             var pdfsize = pdf / 1024;
             if (pdfsize > 51200) {
                 this.$alert("Pdf size cannot be greater than 50mb")
                 document.getElementById('file').value = null
                 this.file=null
                 this.deletemodal = false;
                 this.isLoading=false;
                 return false;
             }
     }
        var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
        
        var selectedFile = document.getElementById("file").files;
        var fileToLoad = selectedFile[0];

        let reader = new FileReader()
					reader.readAsDataURL(fileToLoad)
					let pdfStream = await new Promise((resolve, reject) => {
						reader.onload = function () {
							this.base64String = reader.result.replace("", "")
							resolve(this.base64String)
						}
					})
       
        let result = await axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'uploadfile',
          'data': {
            body: pdfStream,
            key: 'dr/invoice/'+this.invreferenceid+'.pdf'
          },
          'headers': {
            'Authorization': 'Bearer ' + myStr,
          }
        })
					.then(async (response) => {
            this.updatedinvoiceurl = response.data.url
            resolve( this.updatedinvoiceurl);
          })
    })
  },
    getdate1(date) {
      let today = new Date(date);
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      let today1 = yyyy + '-' + mm + '-' + dd;
      return today1;
    },


    // validateDate() {
    // 	var currentDate = new Date();
    // 	var InvoiceDate = new Date(this.addinward.invoicedate);
    //
    // 	if (Date.parse(InvoiceDate) <= Date.parse(currentDate)) {
    // 		console.log("here");
    // 		this.isDateError = false;
    // 		this.Dateerrors = '';
    // 		return true;
    // 	} else {
    // 		this.isDateError = true;
    // 		this.Dateerrors = 'Invoice date should always be less than or same as current date';
    // 		return false;
    // 	}
    // },

    //validate all form fields on onsubmit()
    onSubmitForm: function (event) {
      this.inwardErrors = {};
      this.isError = false;

      if (!this.addinward.vendor) {
        this.isError = true;
        this.inwardErrors.vendor = this.$t('common.merchantError');
      }
      if (!this.addinward.invoiceno) {
        this.isError = true;
        this.inwardErrors.invoiceno = this.$t('inwardList.inward.invoiceNoError');
      }

      if (!this.addinward.invoicevalue) {
        this.isError = true;
        this.inwardErrors.invoicevalue = this.$t('inwardList.inward.invoiceValueError');
      }
      if (this.addinward.invoicevalue && isNaN(this.addinward.invoicevalue)) {
        this.isError = true;
        this.inwardErrors.invoicevalue = this.$t('inwardList.inward.invoiceNumericError');
      }

      if (!this.addinward.noofboxes) {
        this.isError = true;
        this.inwardErrors.noofboxes = this.$t('inwardList.inward.noOfBoxesError');
      }
      if (this.addinward.noofboxes && isNaN(this.addinward.noofboxes)) {
        this.isError = true;
        this.inwardErrors.noofboxes = this.$t('inwardList.inward.noOfBoxesNumericError');
      }


      if (this.addinward.damagedboxes && isNaN(this.addinward.damagedboxes)) {
        this.isError = true;
        this.inwardErrors.damagedboxes = this.$t('inwardList.inward.damagedBoxesNumericError');
      }

      if (!this.addinward.SKU) {
        this.isError = true;
        this.inwardErrors.SKU = this.$t('inwardList.inward.totalSKUError');
      }
      if (this.addinward.SKU && isNaN(this.addinward.SKU)) {
        this.isError = true;
        this.inwardErrors.SKU = this.$t('inwardList.inward.totalSKUNumericError');
      }

      if (!this.addinward.InvoiceQty) {
        this.isError = true;
        this.inwardErrors.InvoiceQty = this.$t('inwardList.inward.totalInvoiceQuantityError');
      }
      if (this.addinward.InvoiceQty && isNaN(this.addinward.InvoiceQty)) {
        this.isError = true;
        this.inwardErrors.InvoiceQty = this.$t('inwardList.inward.totalInvoiceQuantityNumericError');
      }

      if (Number(this.addinward.SKU) > Number(this.addinward.InvoiceQty)) {
        this.isError = true;
        this.inwardErrors.InvoiceQty = this.$t('inwardList.inward.totalInvoiceQuantityLessError');
      }

      if (!this.addinward.invoicedate) {
        this.isError = true;
        this.inwardErrors.invoicedate = this.$t('inwardList.inward.invoiceDateError');
      }
      if (this.addinward.invoicedate) {
        let currentDate = new Date();
        let invoiceDate = new Date(this.addinward.invoicedate);

        if (invoiceDate > currentDate) {
          this.isError = true;
          this.inwardErrors.invoicedate = this.$t('inwardList.inward.invoiceDateNumericError');
        }
      }

      if (this.addinward.damagedboxes && this.addinward.damagedboxes > 0) {
        if (!this.addinward.damagereasons) {
          this.isError = true;
          this.inwardErrors.damagereasons = this.$t('inwardList.inward.damageReasonError');
        }
      }

      if (this.isError) {
        event.preventDefault();
        return false;
      } else {
        this.saveInward();
        //return true;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/inwardEdit/inwardEdit.component.js